import React from "react";

export default function Header(props) {
  return (
    <header className="App-header">
      {props.children}
    </header>
  );
}